import TabPage from "../../../projectx/factories/tab-page";
import "./../../factories/shift-schedule-swap-employees-dialog";
import "../../../projectx/bindings/bao-searcher";
import * as $ from "jquery";
import Bao from "../../../projectx/services/bao-service";
import * as ko from "knockout";
import * as moment from "moment";
import BaoDialog from "../../../projectx/factories/bao-dialog";
import baoRouter from "../../../projectx/services/bao-router";
//let SwapDialog = window.baorequire("Factories/ShiftScheduleSwapEmployeesDialog");

// view-model for QualificationOverview report in report center
class QualificationOverviewReport {
    Bao = Bao;
    TabPage: TabPage;
    Parent;
    ReportHTML: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    CellOverlay: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    RequiredQualificationCollection: KnockoutObservableArray<any> = ko.observableArray([]);
    QualificationOverviewReportModelsShiftGroup1: KnockoutObservableArray<any> = ko.observableArray([]);
    QualificationOverviewReportModelsShiftGroup2: KnockoutObservableArray<any> = ko.observableArray([]);
    QualificationOverviewReportModelsShiftGroup3: KnockoutObservableArray<any> = ko.observableArray([]);
    QualificationOverviewReportModelsShiftGroup4: KnockoutObservableArray<any> = ko.observableArray([]);
    QualificationOverviewReportModelsShiftGroup5: KnockoutObservableArray<any> = ko.observableArray([]);
    QualificationOverviewReportModelsTemporary: KnockoutObservableArray<any> = ko.observableArray([]);
    Overview: KnockoutObservableArray<any> = ko.observableArray([]);
    HeaderLeft: KnockoutObservable<string> = ko.observable('0');
    SidebarTop: KnockoutObservable<string> = ko.observable('0');
    ShiftBookId = ko.observable('');
    ShiftBookName = ko.observable('');
    QualificationTypeIds = ko.observable('');
    QualificationTypeName = ko.observable('')
    ShiftBook = ko.observable();
    SearcherShiftBook: Bindings.baoSearcher = {
        ObjectId: this.ShiftBookId,
        ObjectValue: 'Name',
        SearchType: 'ShiftBook',
        SelectedItem: this.ShiftBook,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: {
            CurrentUserHasReadPermission: true,
            ShiftbookTypeId: '1AB743AA-C33C-4DB9-8920-3C8E79B501E3'
        }
    };
    QualificationTypes = ko.observableArray();
    SearchQualificationType: Bindings.baoSearcher = {
        ObjectId: this.QualificationTypeIds,
        ObjectValue: 'Name',
        SearchType: 'QualificationType',
        SelectedItem: this.QualificationTypes,
        AutoComplete: true,
        AutoSearch: true,
        MultiSelect: true,
        CustomFilter: { CurrentUserHasReadPermission: true }
    };
    constructor(parent: any, params: any) {
        this.Parent = parent;
        this.TabPage = parent.TabPage;
        this.TabPage.IsActiveTab.subscribe(() => {
            if (this.TabPage.IsActiveTab()) {
                this.recalcSchedulePosition();
                this.recalcScroll();
            }
        });
    }
    loaded() {
        this.TabPage.IsLoading(true);
        $(this.ReportHTML()).parents(".col-lg-12").eq(1).find("select.form-control").eq(0).css({ "position": "fixed", "width": "65.7%", "z-index": "500" });
        this.recalcSchedulePosition();
        this.recalcScroll();
        this.TabPage.IsLoading(false);
    }
    public recalcScroll() {
        //this.SidebarTop($(this.ReportHTML()).find("#content")[0].getBoundingClientRect().top + 'px');
        this.HeaderLeft(-window.pageXOffset + 'px');
    }
    public recalcSchedulePosition() {
        $(this.ReportHTML()).find(".shift-supervisor-occupation-table").css("top", $(this.ReportHTML()).find(".filters").height() + 33);
    }
    public resizeEventHandler = (e) => {
        this.recalcSchedulePosition();
        this.recalcScroll();
    };
    public scrollEventHandler = (e) => {
        e.preventDefault();
        this.recalcScroll();
    };
    public beforeClose() {
        // remove the eventlistener
        window.removeEventListener('scroll', this.scrollEventHandler);
        window.removeEventListener('resize', this.resizeEventHandler);
        $(this.ReportHTML()).parents(".col-lg-12").eq(1).find("select.form-control").eq(0).css({ "position": "static", "width": "100%", "z-index": "inherit" });
    }
    Display = () => {
        if (this.ShiftBookId()) {
            this.TabPage.IsLoading(true);
            this.getDataFromServer().then(() => this.TabPage.IsLoading(false));
        }
        else {
            let baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
    };
    public getDataFromServer(): JQueryPromise<void> {
        return Bao.post("ReportCenter/GetQualificationOverviewReportModel", JSON.stringify({
            shiftbookId: this.ShiftBookId(),
            qualificationIds: this.QualificationTypeIds()
        })).then(result => {
            this.QualificationOverviewReportModelsShiftGroup1(result.QualificationOverviewReportModelsShiftGroup1);
            this.QualificationOverviewReportModelsShiftGroup2(result.QualificationOverviewReportModelsShiftGroup2);
            this.QualificationOverviewReportModelsShiftGroup3(result.QualificationOverviewReportModelsShiftGroup3);
            this.QualificationOverviewReportModelsShiftGroup4(result.QualificationOverviewReportModelsShiftGroup4);
            this.QualificationOverviewReportModelsShiftGroup5(result.QualificationOverviewReportModelsShiftGroup5);
            this.QualificationOverviewReportModelsTemporary(result.QualificationOverviewReportModelsShiftGroupTemporary);
            this.RequiredQualificationCollection(result.RequiredQualificationCollection);
            this.Overview(result.Overview);
        });
    }
}
export default QualificationOverviewReport;